module.exports = __webpack_public_path__ + "img/vaio.6f51e6cc.svg";